import AddIcon from '@mui/icons-material/Add';
import { Button, Toolbar } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import AddCRMAccount from './addCRMAccount';
import { useTranslation } from 'react-i18next';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1, 0, 3),
}));

export default function CRMToolbar({ handleRefreshGrid }) {
  const { t: translate } = useTranslation();
  const [openWorkPlaceModal, setWorkPlaceModal] = useState(false);
  const handleWorkPlaceClick = () => {
    setWorkPlaceModal(true);
  };
  const handleClose = () => {
    setWorkPlaceModal(false);
  };
  const handleSuccess = () => {
    setWorkPlaceModal(false);
    handleRefreshGrid(true);
  };

  return (
    <>
      <StyledRoot>
        <Button variant="contained" startIcon={<AddIcon />} onClick={handleWorkPlaceClick}>
          {translate('crm.add_webhook_subscription_accounts')}
        </Button>
      </StyledRoot>
      {openWorkPlaceModal && <AddCRMAccount handleClose={handleClose} handleSuccess={handleSuccess} />}
    </>
  );
}
